import { useEffect, useState } from "react";
import axios from "axios";
import { Quote, Star } from "lucide-react";

// Placeholder notes shown only until the owner approves real ones from families
const SAMPLE = [
  {
    name: "Maria L.",
    place: "San Antonio, TX",
    body: "They turned fifty years of fading photos into a film we will treasure forever. There wasn't a dry eye at the service.",
  },
  {
    name: "The Patel Family",
    place: "Edison, NJ",
    body: "The team was gentle, patient, and honored every detail of Papa's story. The music choice made us weep and smile all at once.",
  },
  {
    name: "Rev. James O.",
    place: "Atlanta, GA",
    body: "I've seen many tribute videos, but these feel genuinely cinematic. The families leave the service held together.",
  },
];

export default function Testimonials() {
  const [real, setReal] = useState([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`).then(({ data }) => setReal(data.reviews)).catch(() => {});
  }, []);
  const T = real.length
    ? real.slice(0, 6).map((r) => ({ name: r.display_name, place: r.place, body: r.message, rating: r.rating }))
    : SAMPLE;
  return (
    <section data-testid="testimonials-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-40"
           style={{ background: "radial-gradient(600px 300px at 50% 0%, rgba(230,184,156,0.08), transparent 70%)" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <div className="overline mb-4">Memory Wall</div>
          <h2 className="serif text-4xl sm:text-5xl font-light leading-[1.05] text-[#F5F0E8]">
            Held together, in the hardest week —
            <span className="italic text-[#E6B89C]"> by families like yours.</span>
          </h2>
        </div>

        <div className={`mt-14 grid gap-5 lg:gap-6 ${T.length === 1 ? "max-w-xl" : T.length === 2 ? "md:grid-cols-2 max-w-4xl" : "md:grid-cols-3"}`}>
          {T.map((t, i) => (
            <figure key={i} data-testid={`testimonial-${i}`} className="card-surface p-7 relative">
              <Quote size={22} className="text-[#D4AF37]/60 absolute top-5 right-5" />
              {t.rating && (
                <div className="flex gap-0.5 mb-3" aria-label={`${t.rating} out of 5`}>
                  {[1, 2, 3, 4, 5].map((s) => <Star key={s} size={13} className={s <= t.rating ? "text-[#D4AF37] fill-[#D4AF37]" : "text-[#A0988E]/40"} />)}
                </div>
              )}
              <blockquote className="serif italic text-[20px] text-[#F5F0E8]/95 leading-snug break-words">
                "{t.body}"
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[rgba(197,165,90,0.15)]">
                <div className="text-[#F5F0E8] text-[15px]">{t.name}</div>
                {t.place && <div className="text-xs tracking-widest uppercase text-[#C5A55A]/80 mt-1">{t.place}</div>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
